import { getAuthToken } from "@/services/auth.service";
import { type HttpMethod } from "@/types/api.types";
import { NetworkError, UnauthorizedError } from "@/utils/errors";
import { serverUrls } from "../utils/constants";

export interface ErrorResponse {
  statusCode: number;
  timestamp: string;
  path: string;
  method: string;
  code: string;
  type?: string;
  message?: string;
}

export const callAPI = async <T>(
  method: HttpMethod,
  path: string,
  body?: any
): Promise<T | void> => {
  const token = getAuthToken();
  const headers: HeadersInit = {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin":"*"
  };
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  try {
    const response: Response = await fetch(serverUrls.authUrl + path, {
      method,
      headers,
      body: body ? JSON.stringify(body) : null,
    });

    if (response.status === 401) {
      throw new UnauthorizedError();
    }

    if (response.status === 204) {
      return 
    }

    if (response.ok) {                  
      return (await response.json()).data as T;
    } else{
      let errorData: ErrorResponse | undefined = undefined;
      try {
        errorData = await response.json();
      } catch {
        errorData = undefined;
      }
      const errorMessage = errorData?.code || `Error HTTP ${response.status}`;
      const errorStatus = errorData?.statusCode || response.status;
      const error: any = new Error(errorMessage);
      error.status = errorStatus;
      error.data = errorData;
      throw error;
    }
  } catch (error: any) {        
    if (error instanceof TypeError && error.message === "Failed to fetch") {
      throw new NetworkError();
    }    
    throw error;
  }
};
